export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_13.be3cd220.jpg";